'use strict';

var _defineProperty = require("/app/node_modules/@babel/runtime/helpers/defineProperty");

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _assertThisInitialized = require("/app/node_modules/@babel/runtime/helpers/assertThisInitialized");

var _inherits = require("/app/node_modules/@babel/runtime/helpers/inherits");

var opentracing = require('opentracing');

var Span = opentracing.Span;

var SpanContext = require('./span_context');

var platform = require('../platform');

var constants = require('../constants');

var id = require('../id');

var tagger = require('../tagger');

var SAMPLE_RATE_METRIC_KEY = constants.SAMPLE_RATE_METRIC_KEY;

var DatadogSpan =
/*#__PURE__*/
function (_Span) {
  _inherits(DatadogSpan, _Span);

  function DatadogSpan(tracer, processor, sampler, prioritySampler, fields, debug) {
    var _this;

    _classCallCheck(this, DatadogSpan);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatadogSpan).call(this));
    var operationName = fields.operationName;
    var parent = fields.parent || null;
    var tags = Object.assign(_defineProperty({}, SAMPLE_RATE_METRIC_KEY, sampler.rate()), fields.tags);
    var hostname = fields.hostname;
    _this._parentTracer = tracer;
    _this._debug = debug;
    _this._sampler = sampler;
    _this._processor = processor;
    _this._prioritySampler = prioritySampler;
    _this._spanContext = _this._createContext(parent);
    _this._spanContext._name = operationName;
    _this._spanContext._tags = tags;
    _this._spanContext._hostname = hostname;
    _this._startTime = fields.startTime || _this._getTime();

    if (debug) {
      _this._handle = platform.metrics().track(_assertThisInitialized(_this));
    }

    return _this;
  }

  _createClass(DatadogSpan, [{
    key: "toString",
    value: function toString() {
      var spanContext = this.context();
      var resourceName = spanContext._tags['resource.name'];
      var resource = resourceName.length > 100 ? "".concat(resourceName.substring(0, 97), "...") : resourceName;
      var json = JSON.stringify({
        traceId: spanContext._traceId,
        spanId: spanContext._spanId,
        parentId: spanContext._parentId,
        service: spanContext._tags['service.name'],
        name: spanContext._name,
        resource: resource
      });
      return "Span".concat(json);
    }
  }, {
    key: "_createContext",
    value: function _createContext(parent) {
      var spanContext;

      if (parent) {
        spanContext = new SpanContext({
          traceId: parent._traceId,
          spanId: id(),
          parentId: parent._spanId,
          sampling: parent._sampling,
          baggageItems: Object.assign({}, parent._baggageItems),
          trace: parent._trace
        });
      } else {
        var spanId = id();
        spanContext = new SpanContext({
          traceId: spanId,
          spanId: spanId
        });
      }

      spanContext._trace.started.push(this);

      spanContext._trace.startTime = spanContext._trace.startTime || Date.now();
      spanContext._trace.ticks = spanContext._trace.ticks || platform.now();
      return spanContext;
    }
  }, {
    key: "_getTime",
    value: function _getTime() {
      var _this$_spanContext$_t = this._spanContext._trace,
          startTime = _this$_spanContext$_t.startTime,
          ticks = _this$_spanContext$_t.ticks;
      return startTime + platform.now() - ticks;
    }
  }, {
    key: "_context",
    value: function _context() {
      return this._spanContext;
    }
  }, {
    key: "_tracer",
    value: function _tracer() {
      return this._parentTracer;
    }
  }, {
    key: "_setOperationName",
    value: function _setOperationName(name) {
      this._spanContext._name = name;
    }
  }, {
    key: "_setBaggageItem",
    value: function _setBaggageItem(key, value) {
      this._spanContext._baggageItems[key] = value;
    }
  }, {
    key: "_getBaggageItem",
    value: function _getBaggageItem(key) {
      return this._spanContext._baggageItems[key];
    }
  }, {
    key: "_addTags",
    value: function _addTags(keyValuePairs) {
      tagger.add(this._spanContext._tags, keyValuePairs);
    }
  }, {
    key: "_finish",
    value: function _finish(finishTime) {
      if (this._duration !== undefined) {
        return;
      }

      finishTime = parseFloat(finishTime) || this._getTime();
      this._duration = finishTime - this._startTime;

      this._spanContext._trace.finished.push(this);

      this._spanContext._isFinished = true;

      if (this._debug) {
        this._handle.finish();
      }

      this._processor.process(this);
    }
  }]);

  return DatadogSpan;
}(Span);

module.exports = DatadogSpan;